import { render, staticRenderFns } from "./empty-permissions-page.vue?vue&type=template&id=830113d8&scoped=true&"
import script from "./empty-permissions-page.vue?vue&type=script&lang=js&"
export * from "./empty-permissions-page.vue?vue&type=script&lang=js&"
import style0 from "./empty-permissions-page.vue?vue&type=style&index=0&id=830113d8&lang=scss&scoped=true&"
import style1 from "./empty-permissions-page.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "830113d8",
  null
  
)

export default component.exports
import {QImg,QBtn} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QImg,QBtn})
